import { Toast } from './shared/components/notify-toast/toast.component';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CoreService } from '@core';
import { SplashScreenComponent } from './shared/components/splash-screen/splash-screen.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, Toast, SplashScreenComponent],
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'TailwindAdmin Angular Admin Tempplate';

  constructor(private coreService: CoreService) {}

  ngOnInit(): void {
    // Initialize theme on app startup
    const options = this.coreService.getOptions();
    this.coreService.setOptions(options);
  }
}
